import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    subscription: ''
  }),
  computed: {
    subActiveTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    loggedin (): boolean {
      return this.$store.direct.state.user.userLoggedIn
    }
  },
  watch: {
    subActiveTeam () {
      this.subscribeAssetGroup()
    },
    loggedin () {
      this.subscribeAssetGroup()
    }
  },
  created () {
    this.subscribeAssetGroup()
  },
  beforeDestroy () {
    if (this.subscription !== '') {
      this.$store.direct.dispatch.assets.unsubscribeTeamAssetGroup(this.subscription)
    }
  },
  methods: {
    subscribeAssetGroup () {
      if (this.subActiveTeam !== '' && this.subActiveTeam !== this.subscription && this.loggedin) {
        if (this.subscription !== '') {
          this.$store.direct.dispatch.assets.unsubscribeTeamAssetGroup(this.subscription)
        }

        console.log('--- subscribeAssetGroup')
        this.$store.direct.dispatch.assets.subscribeTeamAssetGroup(this.subActiveTeam)
        this.subscription = this.subActiveTeam
      } else if (!this.loggedin && this.subscription) {
        this.$store.direct.dispatch.assets.unsubscribeTeamAssetGroup(this.subscription)
        this.subscription = ''
      }
    }
  }
})
